import type { ComponentPropsWithoutRef } from 'react'

const baseClasses =
  'inline-flex items-center justify-center min-h-[48px] min-w-[110px] px-6 py-4 rounded-[2px] text-center font-archivo font-bold text-caption-bold leading-[14px]'

const variantClasses = {
  brand: 'bg-brand-greenBright text-brand-green',
  dark: 'bg-gray-dark text-gray-light',
  mid: 'bg-gray-medium text-gray-light',
}

type ButtonVariant = keyof typeof variantClasses

type ButtonProps = ComponentPropsWithoutRef<'button'> & {
  variant?: ButtonVariant
}

function Button({ className, variant = 'brand', ...props }: ButtonProps) {
  const classes = [baseClasses, variantClasses[variant], className]
    .filter(Boolean)
    .join(' ')

  return <button type="button" className={classes} {...props} />
}

export default Button
